import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import BoardPage from './pages/BoardPage'
import DashboardPage from './pages/DashboardPage'
import DecisoesPage from './pages/DecisoesPage'
import PesquisasPage from './pages/PesquisasPage'
import RoadmapPage from './pages/RoadmapPage'

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/quadro" element={<BoardPage />} />
        <Route path="/decisoes" element={<DecisoesPage />} />
        <Route path="/pesquisas" element={<PesquisasPage />} />
        <Route path="/roadmap" element={<RoadmapPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}
